import { useCallback, useEffect, useRef } from "react";

// Late mutations, redirects and key downloads must stay with the initiating scope.
export default function useScopeGuard(scope) {
  const current = useRef({ scope, version: 0, mounted: true });
  if (current.current.scope !== scope) {
    current.current.scope = scope;
    current.current.version++;
  }
  const version = current.current.version;
  useEffect(() => {
    const state = current.current;
    state.mounted = true;
    return () => { state.mounted = false; };
  }, []);
  return useCallback(() => current.current.mounted && current.current.version === version, [version]);
}
